<template>
  <div>
    <div v-if="$store.getters.isAdmin" class="elevation-0">
      <v-btn flat="" @click="form = example">Default fill</v-btn>
      <v-btn flat @click.native="write">Reset Form</v-btn>
    </div>
    <s-form
      v-if="form && visible"
      :title="form.title"
      :description="form.description"
      :steps="form.steps"
      @submit="submit"
    >
      <div v-if="this.form.steps[0].inputs[0].value > 0">
        <br />El precio del campamento es de {{ this.form.price.full }}€, se
        divide en {{ this.form.price.day }}€/dia y {{ this.form.price.bus }}€
        por el transporte de ida y lo mismo por la vuelta. <br />

        <!-- Here is inyected the result -->
        <span v-html="prices"></span>
        <!-- End fo inyected result -->

        <!--<div v-if=""></div>-->
      </div>
    </s-form>
    <div v-if="!visible" transition="scale-transition">
      <v-alert :value="!visible" outline type="success">
        Datos enviados con éxito. Revise su correo para los siguientes pasos
      </v-alert>
      Si no recibe el correo, envíanos un email a
      inscripcionesverano@scouts284.org.in con el numero de ref
      <b>#{{ this.ref }}</b>
    </div>
  </div>
</template>

<script>
import FileUploader from "./formulario/FileUploader";
import SForm from "./formulario/Form";
export default {
  components: {
    SForm,
    FileUploader,
  },
  name: "inscripciones",
  data() {
    return {
      ref: "",
      form: null,
      visible: true,
      example: {
        description:
          "Para realizar la inscripción deberá que cumplimentar los datos que se solicitan a continuación y adjuntar los documentos requeridos. Una vez realizada la solicitud se os confirmará a través de un email donde se os detallará el metodo de pago y la cantidad a pagar. Aquellos que pertenezcan a la misma unidad familiar deberán realizar una única inscripción para poder optar al descuento familiar. Blablablablabla En caso de duda pueden contactarnos a través del correo inscripcionesverano@scouts284.org.in .",
        price: {
          bus: 15,
          day: 15,
        },
        steps: [
          {
            id: "basic",
            inputs: [
              {
                hint: "Numero de personas",
                id: "peopleNumber",
                items: [0, 1, 2, 3, 4, 5, 6, 7],
                rules: ["required"],
                type: "select",
                value: 3,
              },
              {
                hint: "Email",
                id: "email",
                rules: ["required", "email"],
                type: "text",
                value: "prueba@prueba.com",
              },
              {
                hint: "Teléfono",
                id: "phone",
                rules: ["required"],
                type: "text",
                value: "648772810",
              },
              {
                hint: "Teléfono 2",
                id: "phone2",
                rules: ["required"],
                type: "text",
                value: "prueba",
              },
              {
                hint: "Teléfono 3",
                id: "phone3",
                type: "text",
                value: "",
              },
            ],
            title: "Información Básica",
          },
          {
            condition: {
              hidden: {
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
              },
              input: "peopleNumber",
              step: "basic",
            },
            detail: ["name", "lastname"],
            hidden: false,
            id: "person1",
            inputs: [
              {
                text: "Información",
                type: "section",
              },
              {
                hint: "Nombre",
                id: "name",
                rules: ["required"],
                type: "text",
                value: "Jaime",
              },
              {
                hint: "Apellido",
                id: "lastname",
                rules: ["required"],
                type: "text",
                value: "Blasco",
              },
              {
                hint: "Fecha de Nacimiento",
                id: "birthday",
                rules: ["required"],
                type: "date",
                value: "2007-04-17",
              },
              {
                hint: "Rama",
                id: "rama",
                items: [
                  "Castores",
                  "Lobatos",
                  "Tropa",
                  "Escultas",
                  "Rovers",
                  "Scouter",
                  "Cabaña",
                ],
                rules: ["required"],
                type: "select",
                value: "Tropa",
              },
              {
                condition: {
                  input: "rama",
                  items: {
                    Castores: ["Cherokee", "Kiowa"],
                    Lobatos: ["Chikay", "Dewanee", "Ethawa", "Segowlee"],
                    Rovers: ["Clan", "Comuna"],
                    Tropa: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                    Escultas: ["Vorbassen", "Yangoru"],
                  },
                },
                hidden: null,
                hint: "Unidad",
                id: "unidad",
                items: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                rules: ["required"],
                type: "select",
                value: "Wargos",
              },
              {
                hint: "Dias de Campamento (selecionado todo por defecto)",
                id: "days",
                items: [
                  "14",
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                ],
                rules: ["required"],
                size: 2,
                type: "multiple-select",
                value: [
                  "14",
                  "15",
                  "16",
                  "17",
                  "18",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                ],
              },
              {
                hint: "Buses (selecionados por defecto)",
                id: "bus",
                items: ["ida", "vuelta"],
                type: "multiple-select",
                value: [],
              },
              {
                text: "Ficha Médica",
                type: "section",
              },
              {
                hint: "Alergias",
                id: "alergias",
                type: "textarea",
                value: "Si tengo",
              },
              {
                hint: "Operaciones",
                id: "operaciones",
                type: "textarea",
                value: "Puede que tenga",
              },
              {
                hint: "Enfermedades",
                id: "enfermedades",
                type: "textarea",
                value: "No tengo",
              },
              {
                hint: "Seguridad Social",
                id: "seguridad_social",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: ["images/1.jpg"],
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: false,
                hint: "Cartilla de vacunación",
                id: "cartilla_vacunacion",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: ["images/0- Presentación.ppt"],
              },
              {
                hint: "Documentos médicos",
                id: "docs",
                max: 3,
                type: "file",
                value: ["images/0- Presentación.ppt"],
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: false,
                hint: "Peso",
                id: "peso",
                rules: ["required"],
                suffix: "kg",
                type: "text",
                value: "15",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: false,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: false,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: false,
                text: "Autorizaciones",
                type: "section",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: false,
                hint: "Autorización",
                id: "autorizacion",
                max: 1,
                rules: ["required"],
                type: "file",
                value: ["images/1.Presentación.pdf"],
              },
            ],
            title: "Persona 1",
          },
          {
            condition: {
              hidden: {
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
              },
              input: "peopleNumber",
              step: "basic",
            },
            detail: ["name", "lastname"],
            hidden: false,
            id: "person2",
            inputs: [
              {
                text: "Información",
                type: "section",
              },
              {
                hint: "Nombre",
                id: "name",
                rules: ["required"],
                type: "text",
                value: "Celia ",
              },
              {
                hint: "Apellido",
                id: "lastname",
                rules: ["required"],
                type: "text",
                value: "Blasco",
              },
              {
                hint: "Fecha de Nacimiento",
                id: "birthday",
                rules: ["required"],
                type: "date",
                value: "1920-05-15",
              },
              {
                hint: "Rama",
                id: "rama",
                items: [
                  "Castores",
                  "Lobatos",
                  "Tropa",
                  "Escultas",
                  "Rovers",
                  "Scouter",
                  "Cabaña",
                ],
                rules: ["required"],
                type: "select",
                value: "Scouter",
              },
              {
                condition: {
                  input: "rama",
                  items: {
                    Castores: ["Cherokee", "Kiowa"],
                    Lobatos: ["Chikay", "Dewanee", "Ethawa", "Segowlee"],
                    Rovers: ["Clan", "Comuna"],
                    Tropa: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                    Escultas: ["Vorbassen", "Yangoru"],
                  },
                },
                hidden: true,
                hint: "Unidad",
                id: "unidad",
                items: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                rules: ["required"],
                type: "select",
                value: null,
              },
              {
                hint: "Dias de Campamento (selecionado todo por defecto)",
                id: "days",
                items: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
                rules: ["required"],
                size: 2,
                type: "multiple-select",
                value: [
                  "17",
                  "18",
                  "20",
                  "21",
                  "23",
                  "24",
                  "25",
                  "26",
                  "28",
                  "29",
                  "30",
                ],
              },
              {
                hint: "Buses (selecionados por defecto)",
                id: "bus",
                items: ["ida", "vuelta"],
                type: "multiple-select",
                value: ["ida", "vuelta"],
              },
              {
                text: "Ficha Médica",
                type: "section",
              },
              {
                hint: "Alergias",
                id: "alergias",
                type: "textarea",
                value: "Esto no",
              },
              {
                hint: "Operaciones",
                id: "operaciones",
                type: "textarea",
              },
              {
                hint: "Enfermedades",
                id: "enfermedades",
                type: "textarea",
              },
              {
                hint: "Seguridad Social",
                id: "seguridad_social",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: ["images/0- Presentación.ppt"],
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Cartilla de vacunación",
                id: "cartilla_vacunacion",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: null,
              },
              {
                hint: "Documentos médicos",
                id: "docs",
                max: 3,
                type: "file",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Peso",
                id: "peso",
                rules: ["required"],
                suffix: "kg",
                type: "text",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                text: "Autorizaciones",
                type: "section",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Autorización",
                id: "autorizacion",
                max: 1,
                rules: ["required"],
                type: "file",
                value: null,
              },
            ],
            title: "Persona 2",
          },
          {
            condition: {
              hidden: {
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
              },
              input: "peopleNumber",
              step: "basic",
            },
            detail: ["name", "lastname"],
            hidden: false,
            id: "person3",
            inputs: [
              {
                text: "Información",
                type: "section",
              },
              {
                hint: "Nombre",
                id: "name",
                rules: ["required"],
                type: "text",
                value: "Visita",
              },
              {
                hint: "Apellido",
                id: "lastname",
                rules: ["required"],
                type: "text",
                value: "Sin nombre",
              },
              {
                hint: "Fecha de Nacimiento",
                id: "birthday",
                rules: ["required"],
                type: "date",
                value: "1937-08-23",
              },
              {
                hint: "Rama",
                id: "rama",
                items: [
                  "Castores",
                  "Lobatos",
                  "Tropa",
                  "Escultas",
                  "Rovers",
                  "Scouter",
                  "Cabaña",
                ],
                rules: ["required"],
                type: "select",
                value: "Rovers",
              },
              {
                condition: {
                  input: "rama",
                  items: {
                    Castores: ["Cherokee", "Kiowa"],
                    Lobatos: ["Chikay", "Dewanee", "Ethawa", "Segowlee"],
                    Rovers: ["Clan", "Comuna"],
                    Tropa: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                    Escultas: ["Vorbassen", "Yangoru"],
                  },
                },
                hidden: null,
                hint: "Unidad",
                id: "unidad",
                items: ["Clan", "Comuna"],
                rules: ["required"],
                type: "select",
                value: "Comuna",
              },
              {
                hint: "Dias de Campamento (selecionado todo por defecto)",
                id: "days",
                items: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
                rules: ["required"],
                size: 2,
                type: "multiple-select",
                value: [
                  "15",
                  "16",
                  "18",
                  "19",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "30",
                ],
              },
              {
                hint: "Buses (selecionados por defecto)",
                id: "bus",
                items: ["ida", "vuelta"],
                type: "multiple-select",
                value: ["ida"],
              },
              {
                text: "Ficha Médica",
                type: "section",
              },
              {
                hint: "Alergias",
                id: "alergias",
                type: "textarea",
                value: "Si muchas",
              },
              {
                hint: "Operaciones",
                id: "operaciones",
                type: "textarea",
              },
              {
                hint: "Enfermedades",
                id: "enfermedades",
                type: "textarea",
              },
              {
                hint: "Seguridad Social",
                id: "seguridad_social",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: ["images/1Test-Enunciado-20-04-2015.pdf"],
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Cartilla de vacunación",
                id: "cartilla_vacunacion",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: null,
              },
              {
                hint: "Documentos médicos",
                id: "docs",
                max: 3,
                type: "file",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Peso",
                id: "peso",
                rules: ["required"],
                suffix: "kg",
                type: "text",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                text: "Autorizaciones",
                type: "section",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Autorización",
                id: "autorizacion",
                max: 1,
                rules: ["required"],
                type: "file",
                value: null,
              },
            ],
            title: "Persona 3",
          },
          {
            condition: {
              hidden: {
                4: false,
                5: false,
                6: false,
                7: false,
              },
              input: "peopleNumber",
              step: "basic",
            },
            detail: ["name", "lastname"],
            hidden: true,
            id: "person4",
            inputs: [
              {
                text: "Información",
                type: "section",
              },
              {
                hint: "Nombre",
                id: "name",
                rules: ["required"],
                type: "text",
                value: "",
              },
              {
                hint: "Apellido",
                id: "lastname",
                rules: ["required"],
                type: "text",
                value: "",
              },
              {
                hint: "Fecha de Nacimiento",
                id: "birthday",
                rules: ["required"],
                type: "date",
                value: null,
              },
              {
                hint: "Rama",
                id: "rama",
                items: [
                  "Castores",
                  "Lobatos",
                  "Tropa",
                  "Escultas",
                  "Rovers",
                  "Scouter",
                  "Cabaña",
                ],
                rules: ["required"],
                type: "select",
                value: null,
              },
              {
                condition: {
                  input: "rama",
                  items: {
                    Castores: ["Cherokee", "Kiowa"],
                    Lobatos: ["Chikay", "Dewanee", "Ethawa", "Segowlee"],
                    Rovers: ["Clan", "Comuna"],
                    Tropa: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                    Escultas: ["Vorbassen", "Yangoru"],
                  },
                },
                hidden: true,
                hint: "Unidad",
                id: "unidad",
                items: [],
                rules: ["required"],
                type: "select",
                value: null,
              },
              {
                hint: "Dias de Campamento (selecionado todo por defecto)",
                id: "days",
                items: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
                rules: ["required"],
                size: 2,
                type: "multiple-select",
                value: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
              },
              {
                hint: "Buses (selecionados por defecto)",
                id: "bus",
                items: ["ida", "vuelta"],
                type: "multiple-select",
                value: ["ida", "vuelta"],
              },
              {
                text: "Ficha Médica",
                type: "section",
              },
              {
                hint: "Alergias",
                id: "alergias",
                type: "textarea",
              },
              {
                hint: "Operaciones",
                id: "operaciones",
                type: "textarea",
              },
              {
                hint: "Enfermedades",
                id: "enfermedades",
                type: "textarea",
              },
              {
                hint: "Seguridad Social",
                id: "seguridad_social",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Cartilla de vacunación",
                id: "cartilla_vacunacion",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: null,
              },
              {
                hint: "Documentos médicos",
                id: "docs",
                max: 3,
                type: "file",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Peso",
                id: "peso",
                rules: ["required"],
                suffix: "kg",
                type: "text",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                text: "Autorizaciones",
                type: "section",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Autorización",
                id: "autorizacion",
                max: 1,
                rules: ["required"],
                type: "file",
                value: null,
              },
            ],
            title: "Persona 4",
          },
          {
            condition: {
              hidden: {
                5: false,
                6: false,
                7: false,
              },
              input: "peopleNumber",
              step: "basic",
            },
            detail: ["name", "lastname"],
            hidden: true,
            id: "person5",
            inputs: [
              {
                text: "Información",
                type: "section",
              },
              {
                hint: "Nombre",
                id: "name",
                rules: ["required"],
                type: "text",
                value: "",
              },
              {
                hint: "Apellido",
                id: "lastname",
                rules: ["required"],
                type: "text",
                value: "",
              },
              {
                hint: "Fecha de Nacimiento",
                id: "birthday",
                rules: ["required"],
                type: "date",
                value: null,
              },
              {
                hint: "Rama",
                id: "rama",
                items: [
                  "Castores",
                  "Lobatos",
                  "Tropa",
                  "Escultas",
                  "Rovers",
                  "Scouter",
                  "Cabaña",
                ],
                rules: ["required"],
                type: "select",
                value: null,
              },
              {
                condition: {
                  input: "rama",
                  items: {
                    Castores: ["Cherokee", "Kiowa"],
                    Lobatos: ["Chikay", "Dewanee", "Ethawa", "Segowlee"],
                    Rovers: ["Clan", "Comuna"],
                    Tropa: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                    Escultas: ["Vorbassen", "Yangoru"],
                  },
                },
                hidden: true,
                hint: "Unidad",
                id: "unidad",
                items: [],
                rules: ["required"],
                type: "select",
                value: null,
              },
              {
                hint: "Dias de Campamento (selecionado todo por defecto)",
                id: "days",
                items: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
                rules: ["required"],
                size: 2,
                type: "multiple-select",
                value: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
              },
              {
                hint: "Buses (selecionados por defecto)",
                id: "bus",
                items: ["ida", "vuelta"],
                type: "multiple-select",
                value: ["ida", "vuelta"],
              },
              {
                text: "Ficha Médica",
                type: "section",
              },
              {
                hint: "Alergias",
                id: "alergias",
                type: "textarea",
              },
              {
                hint: "Operaciones",
                id: "operaciones",
                type: "textarea",
              },
              {
                hint: "Enfermedades",
                id: "enfermedades",
                type: "textarea",
              },
              {
                hint: "Seguridad Social",
                id: "seguridad_social",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Cartilla de vacunación",
                id: "cartilla_vacunacion",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: null,
              },
              {
                hint: "Documentos médicos",
                id: "docs",
                max: 3,
                type: "file",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Peso",
                id: "peso",
                rules: ["required"],
                suffix: "kg",
                type: "text",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                text: "Autorizaciones",
                type: "section",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Autorización",
                id: "autorizacion",
                max: 1,
                rules: ["required"],
                type: "file",
                value: null,
              },
            ],
            title: "Persona 5",
          },
          {
            condition: {
              hidden: {
                6: false,
                7: false,
              },
              input: "peopleNumber",
              step: "basic",
            },
            detail: ["name", "lastname"],
            hidden: true,
            id: "person6",
            inputs: [
              {
                text: "Información",
                type: "section",
              },
              {
                hint: "Nombre",
                id: "name",
                rules: ["required"],
                type: "text",
                value: "",
              },
              {
                hint: "Apellido",
                id: "lastname",
                rules: ["required"],
                type: "text",
                value: "",
              },
              {
                hint: "Fecha de Nacimiento",
                id: "birthday",
                rules: ["required"],
                type: "date",
                value: null,
              },
              {
                hint: "Rama",
                id: "rama",
                items: [
                  "Castores",
                  "Lobatos",
                  "Tropa",
                  "Escultas",
                  "Rovers",
                  "Scouter",
                  "Cabaña",
                ],
                rules: ["required"],
                type: "select",
                value: null,
              },
              {
                condition: {
                  input: "rama",
                  items: {
                    Castores: ["Cherokee", "Kiowa"],
                    Lobatos: ["Chikay", "Dewanee", "Ethawa", "Segowlee"],
                    Rovers: ["Clan", "Comuna"],
                    Tropa: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                    Escultas: ["Vorbassen", "Yangoru"],
                  },
                },
                hidden: true,
                hint: "Unidad",
                id: "unidad",
                items: [],
                rules: ["required"],
                type: "select",
                value: null,
              },
              {
                hint: "Dias de Campamento (selecionado todo por defecto)",
                id: "days",
                items: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
                rules: ["required"],
                size: 2,
                type: "multiple-select",
                value: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
              },
              {
                hint: "Buses (selecionados por defecto)",
                id: "bus",
                items: ["ida", "vuelta"],
                type: "multiple-select",
                value: ["ida", "vuelta"],
              },
              {
                text: "Ficha Médica",
                type: "section",
              },
              {
                hint: "Alergias",
                id: "alergias",
                type: "textarea",
              },
              {
                hint: "Operaciones",
                id: "operaciones",
                type: "textarea",
              },
              {
                hint: "Enfermedades",
                id: "enfermedades",
                type: "textarea",
              },
              {
                hint: "Seguridad Social",
                id: "seguridad_social",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Cartilla de vacunación",
                id: "cartilla_vacunacion",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: null,
              },
              {
                hint: "Documentos médicos",
                id: "docs",
                max: 3,
                type: "file",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Peso",
                id: "peso",
                rules: ["required"],
                suffix: "kg",
                type: "text",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                text: "Autorizaciones",
                type: "section",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Autorización",
                id: "autorizacion",
                max: 1,
                rules: ["required"],
                type: "file",
                value: null,
              },
            ],
            title: "Persona 6",
          },
          {
            condition: {
              hidden: {
                7: false,
              },
              input: "peopleNumber",
              step: "basic",
            },
            detail: ["name", "lastname"],
            hidden: true,
            id: "person7",
            inputs: [
              {
                text: "Información",
                type: "section",
              },
              {
                hint: "Nombre",
                id: "name",
                rules: ["required"],
                type: "text",
                value: "",
              },
              {
                hint: "Apellido",
                id: "lastname",
                rules: ["required"],
                type: "text",
                value: "",
              },
              {
                hint: "Fecha de Nacimiento",
                id: "birthday",
                rules: ["required"],
                type: "date",
                value: null,
              },
              {
                hint: "Rama",
                id: "rama",
                items: [
                  "Castores",
                  "Lobatos",
                  "Tropa",
                  "Escultas",
                  "Rovers",
                  "Scouter",
                  "Cabaña",
                ],
                rules: ["required"],
                type: "select",
                value: null,
              },
              {
                condition: {
                  input: "rama",
                  items: {
                    Castores: ["Cherokee", "Kiowa"],
                    Lobatos: ["Chikay", "Dewanee", "Ethawa", "Segowlee"],
                    Rovers: ["Clan", "Comuna"],
                    Tropa: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                    Escultas: ["Vorbassen", "Yangoru"],
                  },
                },
                hidden: true,
                hint: "Unidad",
                id: "unidad",
                items: [],
                rules: ["required"],
                type: "select",
                value: null,
              },
              {
                hint: "Dias de Campamento (selecionado todo por defecto)",
                id: "days",
                items: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
                rules: ["required"],
                size: 2,
                type: "multiple-select",
                value: [
                  "15",
                  "16",
                  "17",
                  "18",
                  "19",
                  "20",
                  "21",
                  "22",
                  "23",
                  "24",
                  "25",
                  "26",
                  "27",
                  "28",
                  "29",
                  "30",
                ],
              },
              {
                hint: "Buses (selecionados por defecto)",
                id: "bus",
                items: ["ida", "vuelta"],
                type: "multiple-select",
                value: ["ida", "vuelta"],
              },
              {
                text: "Ficha Médica",
                type: "section",
              },
              {
                hint: "Alergias",
                id: "alergias",
                type: "textarea",
              },
              {
                hint: "Operaciones",
                id: "operaciones",
                type: "textarea",
              },
              {
                hint: "Enfermedades",
                id: "enfermedades",
                type: "textarea",
              },
              {
                hint: "Seguridad Social",
                id: "seguridad_social",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Cartilla de vacunación",
                id: "cartilla_vacunacion",
                max: 1,
                rules: ["required"],
                type: "file",
                types: "image/jpeg, image/png",
                value: null,
              },
              {
                hint: "Documentos médicos",
                id: "docs",
                max: 3,
                type: "file",
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Peso",
                id: "peso",
                rules: ["required"],
                suffix: "kg",
                type: "text",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                type: "space",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                text: "Autorizaciones",
                type: "section",
                value: null,
              },
              {
                condition: {
                  hidden: "<01-12-2000",
                  input: "birthday",
                },
                hidden: true,
                hint: "Autorización",
                id: "autorizacion",
                max: 1,
                rules: ["required"],
                type: "file",
                value: null,
              },
            ],
            title: "Persona 7",
          },
        ],
        title: "Campamento de Verano 2019",
      },
    };
  },
  computed: {
    prices() {
      return this.calculatePrice().html;
    },
  },
  firestore() {
    return {
      //form: this.$db.collection("forms").doc("inscripciones"),
      form: this.$db.collection("formulario").doc("contenido"),
    };
  },
  methods: {
    submit(form) {
      //console.log(this.form);
      form.status = "REGISTRERED";
      form.created = new Date();
      form.people = [];
      form.price = this.calculatePrice().total;
      delete form.basic;
      var self = this;

      var batch = this.$db.batch();
      var ref = this.$db.collection("forms").doc("inscripciones");
      var refForm = ref.collection("answers").doc();

      this.ref = refForm.id;

      for (var i = 1; i <= form.peopleNumber; i++) {
        var refPerson = ref.collection("people").doc();
        var person = form[`person${i}`];
        person.status = "unrevised";
        delete form[`person${i}`];
        person.booking = refForm;

        batch.set(refPerson, person);
        form.people.push(refPerson);
      }
      batch.set(refForm, form);

      batch
        .commit()
        .then(function () {
          self.visible = false;
          var send = self.$firebase
            .functions()
            .httpsCallable("sendInscriptionEmail");
          send({ email: form.email, price: form.price, id: refForm.id })
            .then(function (result) {
              //console.log(result);
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
        });
    },
    calculatePrice() {
      var html = "";
      var people = this.form.steps[0].inputs[0].value;
      var prices = [];
      var total = 0;
      for (var i = 1; i <= people; i++) {
        //Get as temporal variables the price of day, bus and all
        let priceFull = this.form.price.full;
        let priceDay = this.form.price.day;
        let priceBus = this.form.price.bus;

        //console.log(this.form.steps[i].inputs[4].value);

        var days = this.form.steps[i].inputs[6].value
          ? this.form.steps[i].inputs[6].value.length
          : 0;

        let price;

        //Obtener cantidad de viajes en bus
        let nViajesBus = this.form.steps[i].inputs[7].value.length;

        if (days == 16 && nViajesBus == 2) {
          //Ponemos como precio el de todos los dias
          price = priceFull;

          //Ponemos el mensaje de todos los dias
          let allDays = `<b>Persona ${i} </b>: Total ${priceFull}€ <br>`;
          html += allDays;
        } else {
          //Calculamos el precio por dia
          var bus = this.form.steps[i].inputs[7].value
            ? this.form.steps[i].inputs[7].value.length
            : 0;

          price = days * priceDay + bus * priceBus;

          var transporte = this.form.steps[i].inputs[7].value.join(" + ");

          //Ponemos el mensaje de parcial
          let partialDays = `<b>Persona ${i}</b>: ${days} ${days > 1 ? "días" : "día"} ${
            transporte.length > 0 ? "+" : ""
          } ${transporte}: ${price}€ <br>`;
          html += partialDays;
        }

        let birthday = this.form.steps[i].inputs[3].value;
          if (birthday) {
            const today = new Date();
            const birthDate = new Date(birthday);
            console.log(birthDate);
            console.log(today);
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            // Ajustar la edad si el mes/día de cumpleaños no ha llegado aún este año
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            if (age >= 3 && age <= 6) {
              price = price / 2;
              html += `   Persona ${i}: Descuento 50% por edad ${age} años. Precio final -> ${price}€<br>`;
            }else if (age < 3) {
              price = 0;
              html += `   Persona ${i}: Descuento 100% por edad ${age} años. Precio final -> ${price}€<br>`;
            }
          }

        //Set price
        total += price;
        prices.push(price);
      }
      html += `<b>   Total:</b> ${total}€`;
      if (people > 3) {
        html += `<br><br><b>Descuento familiar</b>: Por ser más de 4 personas no se cobrará el campamento más barato `;
        var min = Math.min.apply(null, prices);
        var min1 = Math.min.apply(
          null,
          prices.filter((n) => n != min)
        );
        if (
          min1 == Number.POSITIVE_INFINITY ||
          min1 == Number.NEGATIVE_INFINITY
        )
          min1 = min;
        //console.log(min1);
        var min2 = Math.min.apply(
          null,
          prices.filter((n) => n != min && n != min1)
        );
        if (
          min2 == Number.POSITIVE_INFINITY ||
          min2 == Number.NEGATIVE_INFINITY
        )
          min2 = min1;
        total -= min;
        //console.log(total);
        if (people === 5) {
          html += `y a partir de 5 personas se hará 25% al siguiente campamento más barato`;
          total -= min1 * 0.25;
          //console.log(total);
        } else if (people === 6) {
          html += `y a partir de 6 personas se hará 25% al los 2 campamento siguientes más baratos`;
          total -= (min1 + min2) * 0.25;
          //console.log(total);
        }
        html += `<br><b>Total con descuento:</b> ${total}€`;
      }

      return { total, html };
    },
    person(i) {
      var condition = {};
      for (var j = i; j <= 7; j++) {
        condition[j] = false;
      }
      return {
        title: `Persona ${i}`,
        id: `person${i}`,
        detail: ["name", "lastname"],
        hidden: true,
        condition: {
          step: "basic",
          input: "peopleNumber",
          hidden: condition,
        },
        inputs: [
          { type: "section", text: "Información" },
          {
            id: "name",
            type: "text",
            value: "",
            hint: "Nombre",
            rules: ["required"],
          },
          {
            id: "lastname",
            type: "text",
            value: "",
            hint: "Apellidos",
            rules: ["required"],
          },
          {
            id: "birthday",
            type: "date",
            value: null,
            hint: "Fecha de Nacimiento",
            rules: ["required"],
          },
          {
            id: "rama",
            type: "select",
            value: null,
            items: [
              "Castores",
              "Lobatos",
              "Tropa",
              "Escultas",
              "Rovers",
              "Scouter",
              "Cabaña",
            ],
            hint: "Rama",
            rules: ["required"],
          },
          {
            id: "unidad",
            type: "select",
            value: null,
            hint: "Unidad",
            rules: ["required"],
            items: [],
            hidden: true,
            condition: {
              input: "rama",
              items: {
                Castores: ["Cherokee", "Kiowa"],
                Lobatos: ["Chikay", "Dewanee", "Ethawa", "Segowlee"],
                Tropa: ["Basiliscos", "Wargos", "Fenix", "Centauros"],
                Escultas: ["Vorbassen", "Yangoru"],
                Rovers: ["Clan", "Comuna"],
              },
            },
          },
          {
            id: "days",
            type: "multiple-select",
            hint: "Dias de Campamento (selecionado todo por defecto)",
            value: [
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "24",
              "25",
              "26",
              "27",
              "28",
              "29",
            ],
            items: [
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "24",
              "25",
              "26",
              "27",
              "28",
              "29",
            ],
            rules: ["required"],
            size: 2,
          },
          {
            id: "bus",
            type: "multiple-select",
            hint: "Buses (selecionados por defecto)",
            value: ["ida", "vuelta"],
            items: ["ida", "vuelta"],
          },
          { type: "section", text: "Ficha Médica" },
          {
            id: "alergias",
            type: "textarea",
            rules: ["required"],
            hint: "Alergias",
          },
          {
            id: "operaciones",
            type: "textarea",
            rules: ["required"],
            hint: "Operaciones",
          },
          {
            id: "enfermedades",
            type: "textarea",
            rules: ["required"],
            hint: "Enfermedades",
          },
          {
            id: "seguridad_social",
            type: "file",
            hint: "Seguridad Social",
            rules: ["required"],
            types: "image/jpeg, image/png",
            max: 1,
          },
          {
            id: "cartilla_vacunacion",
            type: "file",
            hint: "Cartilla de vacunación",
            rules: ["required"],
            types: "image/jpeg, image/png",
            max: 1,
            value: null,
          },
          {
            id: "docs",
            type: "file",
            hint: "Documentos médicos o información de interés",
            max: 3,
          },
          {
            id: "peso",
            type: "text",
            suffix: "kg",
            hint: "Peso",
            condition: {
              input: "rama",
              hidden: { Scouter: true, Cabaña: true, default: false },
            },
            rules: ["required"],
            value: null,
            hidden: true,
          },
          {
            type: "space",
            condition: {
              input: "rama",
              hidden: { Scouter: true, Cabaña: true, default: false },
            },
            value: null,
            hidden: true,
          },
          {
            type: "space",
            condition: {
              input: "rama",
              hidden: { Scouter: true, Cabaña: true, default: false },
            },
            value: null,
            hidden: true,
          },
          {
            type: "section",
            text: "Autorizaciones",
            condition: {
              input: "rama",
              hidden: { Scouter: true, Cabaña: true, default: false },
            },
            value: null,
            hidden: true,
          },
          {
            id: "autorizacion",
            type: "file",
            hint: "Autorización (+ Dia de padres)",
            max: 1,
            rules: ["required"],
            condition: {
              input: "rama",
              hidden: { Scouter: true, Cabaña: true, default: false },
            },
            //condition: { input: 'birthday',       hidden: '<01-12-2000'    },
            value: null,
            hidden: true,
          },
        ],
      };
    },
    write() {
      var form = {
        title: "Campamento de Verano 2019",
        price: {
          day: 15,
          bus: 15,
        },
        description:
          "Para realizar la inscripción deberá que cumplimentar los datos que se solicitan a continuación y adjuntar los documentos requeridos. Una vez realizada la solicitud se os confirmará a través de un email donde se os detallará el metodo de pago y la cantidad a pagar. Aquellos que pertenezcan a la misma unidad familiar deberán realizar una única inscripción para poder optar al descuento familiar. Blablablablabla En caso de duda pueden contactarnos a través del correo secretaria@scouts284.org .",
        steps: [
          {
            title: "Información Básica",
            id: "basic",
            inputs: [
              {
                id: "peopleNumber",
                type: "select",
                hint: "Numero de personas",
                value: null,
                items: [0, 1, 2, 3, 4, 5, 6, 7],
                rules: ["required"],
              },
              {
                id: "email",
                type: "text",
                hint: "Email",
                value: "",
                rules: ["required", "email"],
              },
              {
                id: "phone",
                type: "text",
                hint: "Teléfono",
                value: "",
                rules: ["required"],
              },
              {
                id: "phone2",
                type: "text",
                hint: "Teléfono 2",
                value: "",
                rules: ["required"],
              },
              {
                id: "phone3",
                type: "text",
                hint: "Teléfono 3",
                value: "",
              },
            ],
          },
          this.person(1),
          this.person(2),
          this.person(3),
          this.person(4),
          this.person(5),
          this.person(6),
          this.person(7),
          {
            title: "Dia de padres",
            id: "extre",
            inputs: [
              {
                type: "space",
                text: "Numero de personas que comen el dia de padres (niños incluidos)",
              },
              {
                id: "lunch",
                type: "text",
                value: "",
                hint: "Numero de personas",
                rules: ["required"],
              },
              { type: "space" },
              {
                type: "space",
                text: "Puedes añadir cualquier comentario adicional como alergias para la comida del día de padres",
              },
              {
                id: "comentarios",
                type: "textarea",
                hint: "Comentarios adicionales",
              },
            ],
          },
        ],
      };
      //console.log(form);
      this.$db
        .collection("forms")
        .doc("inscripciones")
        .set(form)
        .then(function () {
          console.log("Document successfully written!");
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
        });
    },
  },
};
</script>

<style scoped>
.button--day {
  box-shadow: none !important;
}
.button--day--item {
  box-shadow: none !important;
  background-color: red;
}
</style>